import { render } from "./vRadio.vue?vue&type=template&id=37cf307d&scoped=true"
import script from "./vRadio.vue?vue&type=script&lang=js"
export * from "./vRadio.vue?vue&type=script&lang=js"

import "./vRadio.vue?vue&type=style&index=0&id=37cf307d&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\danil\\PersonalData\\WebsiteDevelopment\\GitHub\\biorobot-factory\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37cf307d"]])

export default __exports__